import {
  DecisionsType,
  DecisionsNativeType,
  DecisionsEnumType,
} from '@decisions/server/DecisionsFramework/Design/Flow/Mapping';
import {
  getDecisionsTypeByFullName,
  getDecisionsTypeFriendlyNames,
  getDecisionsTypeFriendlyName,
} from '@decisions/server/DecisionsFramework/Design/DataStructure/DataStructureService';
import { fillObjectFromDataPairs } from './DataPairUtils';
import { DecisionsDefinedType } from '@decisions/server/DecisionsFramework/Design/Flow/Mapping/DecisionsDefinedType';
import { DataPair } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/ContextData';

export function getDecisionsTypeId(
  type: DecisionsDefinedType | DecisionsType | DecisionsNativeType | DecisionsEnumType
): string {
  return (type as DecisionsDefinedType).DefinitionId || (type as DecisionsNativeType).FullName || type.Name;
}

export function getDecisionsTypeById(id: string): Promise<DecisionsType> {
  return getDecisionsTypeByFullName({
    fullName: id,
  });
}

export async function getTypeDisplayName(type: DecisionsType) {
  const friendlyTypeName = await getFriendlyTypeName(type);
  const typeId = getDecisionsTypeId(type);
  return friendlyTypeName || typeId;
}

let friendlyNamesCache: { [key: string]: string };
let getFriendlyNamesPromise: Promise<DataPair[]> | null;

export async function getFriendlyTypeName(type: DecisionsType): Promise<string> {
  if (!friendlyNamesCache) {
    const friendlyTypes = await (getFriendlyNamesPromise ??
      (getFriendlyNamesPromise = getDecisionsTypeFriendlyNames()));
    getFriendlyNamesPromise = null;
    friendlyNamesCache = fillObjectFromDataPairs(friendlyNamesCache, friendlyTypes);
  }

  const id = getDecisionsTypeId(type);
  if (friendlyNamesCache[id]) {
    return friendlyNamesCache[id];
  }

  const friendlyName = await getDecisionsTypeFriendlyName({
    type,
  });

  return friendlyName;
}
